import { Component, OnInit } from '@angular/core';
import { MobileUiService } from 'src/app/shared/services/mobile-ui.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit {
  isMobile = new BehaviorSubject<boolean>(false);
  showToast: boolean;

  constructor(private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
  }

  close(): void {
    this.showToast = false;
  }

}
